export enum ConsumptionSummaryOriginEnum {
    HOME = "HOME",
    HOME_USAGE = "HOME_USAGE",
    USAGE = "USAGE",
}